import { usePersonFilter } from 'entities/person/lib/hooks/usePersonFilter';
import { selectPersonTagsNames } from 'entities/tags';
import { FilterManager } from 'features/filterManager';
import { TNameMapValue } from 'shared/lib/pagination/types';
import { useAppSelector } from 'shared/lib/store';
import { ModalProvider } from 'shared/ui/modal';
import { FilterCard } from 'shared/ui/pagination';
import { SelectTags } from 'shared/ui/select/selectTags';

export const PersonFilterPanel = () => {
	const tagsNames = useAppSelector(selectPersonTagsNames);
	const nameMap = new Map<string, TNameMapValue>([
		['tags', { name: 'Теги', namesMap: tagsNames }],
	]);

	const { tagsOptions, selectedTagsOptions, changeTags, reset } =
		usePersonFilter();

	return (
		<ModalProvider>
			<FilterCard reset={reset}>
				<SelectTags
					tagsOptions={tagsOptions}
					selectedTagsOptions={selectedTagsOptions}
					changeTags={changeTags}
					label={'Теги карточки гостя'}
				/>
			</FilterCard>
			<FilterManager filterTagsNames={nameMap} />
		</ModalProvider>
	);
};
